import React from 'react';
import classNames from 'classnames';
import { Tooltip } from 'react-tippy';

type TooltipProps = React.ComponentProps<typeof Tooltip>;
type TooltipWithChildrenProps = React.PropsWithChildren<TooltipProps>;
const TooltipWithChildren = Tooltip as React.ComponentType<TooltipWithChildrenProps>;

type Props = React.PropsWithChildren<{
  className?: string;
}> &
  Omit<TooltipProps, 'children' | 'className' | 'size'>;

function TooltipPopOver(props: Props) {
  const { children, className, ...rest } = props;

  return (
    <span>
      <TooltipWithChildren {...rest} className={classNames('tooltip', className)} size="small">
        {children}
      </TooltipWithChildren>
    </span>
  );
}

export default TooltipPopOver;
